"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldName = exports.getFieldIndex = void 0;
const fieldNames = {
    fullName: /full[-_]?name|^name/i,
    firstName: /first[_-]?name/i,
    lastName: /last[_-]?name/i,
    email: /email/i,
    phone: /phone|^tel$/i,
    address: /address|street/i,
    zipcode: /post(al)?[_-]?code|zip/i,
    city: /city/i,
    state: /(^|[^e])state/i,
    radio: /radio/i,
    checkbox: /checkbox/i,
    select: /select/i,
    textarea: /textarea/i,
    text: /text/i,
    input: /input/i
};
const getFieldIndex = (targetField, formElement) => {
    if (!formElement)
        return 0;
    const fields = Array.from(formElement.querySelectorAll('INPUT,SELECT,TEXTAREA'));
    return fields.indexOf(targetField) + 1;
};
exports.getFieldIndex = getFieldIndex;
const getFieldName = (targetField) => {
    return Object.keys(fieldNames).find((name) => {
        return (fieldNames[name].test(targetField.name) ||
            fieldNames[name].test(targetField.type) ||
            fieldNames[name].test(targetField.nodeName));
    });
};
exports.getFieldName = getFieldName;
